import { FC, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Button,
  Card,
  CardContent,
  FormHelperText,
  Typography
} from '@mui/material';
import * as Yup from 'yup'
import { useFormik } from 'formik';
import { SaveAction } from '~/dataProvider/types';
import OdForm, { OnSubmit } from '~/components/formik/OdForm';
import TextField from '~/components/formik/TextField';
import { useLocation } from 'react-router-dom';


export interface PasswordRecoveryBodyProps {
  submit: SaveAction<string>;
}
const validationSchema = 
  Yup.object().shape({
    email: Yup.string().max(255)
      .email('You must use a valid email address.')
      .required('Email is required')
  })

const PasswordRecoveryBody: FC<PasswordRecoveryBodyProps> = ({ submit }) => {
  const location = useLocation<any>()
  const initalEmail : string = (location.state ? location.state['email'] : '') ?? ''
  const initialValues = {
    email: initalEmail,
    submit: null
  }
  
  const onSubmit: OnSubmit<typeof initialValues> = useCallback((values, {
    setErrors,
    setStatus,
    setSubmitting
  }) => {
    submit(values.email, '', {
      onFailure(err) {
        console.error(err);
        setStatus({ success: false });
        setErrors({ submit: err.message });
        setSubmitting(false);
      }
    });

  }, [submit])
  const formikCtrl = useFormik({ initialValues, onSubmit, validationSchema })
  const { errors, isSubmitting } = formikCtrl


  return (
    <>
      <Helmet>
        <title>Password Recovery | OnData</title>
      </Helmet>
          
      <Card role="application" aria-labelledby="pass-recover-title" aria-describedby="pass-recover-description">
        <CardContent sx={{ display: 'flex', flexDirection: 'column', p: 4 }} >
          <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', mb: 3 }} >
            <div>
              <Typography color="textPrimary" gutterBottom variant="h4" id="pass-recover-title" >
                Password Recovery
              </Typography>
              <Typography color="textSecondary" variant="body2" id="pass-recover-description" >
                Forgot your password? We can help! <br/>
                Please enter your email address to reset your password.
              </Typography>
            </div>
          </Box>
          <Box sx={{ flexGrow: 1, mt: 3 }} >
            <OdForm formikCtrl={formikCtrl}>
              <TextField
                autoFocus
                label="Email Address"
                margin="normal"
                name="email"
                type="email"
              />
              {errors.submit && (
                <Box sx={{ mt: 3 }}>
                  <FormHelperText error>
                    {errors.submit}
                  </FormHelperText>
                </Box>
              )}
              <Box sx={{ mt: 3 }}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Submit
                </Button>
              </Box>
            </OdForm>

          </Box>
        </CardContent>
      </Card>
    
    </>
  );
};

export default PasswordRecoveryBody;
